import { faMoneyBill, faVideo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import {  Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { getCourseListApi } from '../../Api/ClientServices'
import Button from '../Button/Button';
import Style from './CoursesList.module.css'
import { separate } from '../../Utils/Seprate/Seprate'
const CoursesList = () => {

    const[courseList,setCourseList]=useState(null)
      useEffect(()=>{
        getCourseList()
      },[])
      const getCourseList=async()=>{
        const data=await getCourseListApi()
        setCourseList(data)
      }
  return (
    <div className={Style.componentHolder}>
        {
            courseList?.courses.map(item=>{
                return(
                  <Card style={{ width: '19rem' }} className={Style.CardHolder}>
                    <Card.Img variant="top" src={`https://cdn.electronicsteps.ir/course/cover/${item.cover}.jpg`}/>
                    <Card.Body className={Style.CardBodyHolder}>
                      <Card.Title className={Style.TitleCardHolder}><FontAwesomeIcon icon={faVideo}/> {item.name}</Card.Title>
                      <Card.Title className={Style.PriceCardHolder}><FontAwesomeIcon icon={faMoneyBill}/> {separate(item.price)} تومان</Card.Title>
                      <Link to={`/course/${item.id}`}><Button Value={'اطلاعات بیشتر'} ClassBtn={'confirmBtn'}/></Link>
                    </Card.Body>
                  </Card>
                )
              })
        }
    </div>
  )
}

export default CoursesList